import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { slide as Menu } from 'react-burger-menu';

import Account from '../../pages/Account';
import Donate from '../../pages/Donate';
import PrivacyPolicy from '../../pages/PrivacyPolicy';
import TermsAndConditions from '../../pages/TermsAndConditions';

import '../../styles/App.css';

import BwossyLogo from "./BwossyLogo"; 
import logo from "../../assets/images/bwossy-logo.svg";

const CustomNavbar = ({ params }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isLogoPressed, setIsLogoPressed] = useState(false);
  const [isAccountOverlayVisible, setAccountOverlayVisible] = useState(false);
  const [isDonateOverlayVisible, setDonateOverlayVisible] = useState(false);
  const [isPrivacyOverlayVisible, setPrivacyOverlayVisible] = useState(false);
  const [isTermsOverlayVisible, setTermsOverlayVisible] = useState(false);

  const handleOpenAccountOverlay = () => setAccountOverlayVisible(true);
  const handleCloseAccountOverlay = () => setAccountOverlayVisible(false);
  const handleOpenDonateOverlay = () => setDonateOverlayVisible(true);
  const handleCloseDonateOverlay = () => setDonateOverlayVisible(false);
  const handleOpenPrivacyOverlay = () => setPrivacyOverlayVisible(true);
  const handleClosePrivacyOverlay = () => setPrivacyOverlayVisible(false);
  const handleOpenTermsOverlay = () => setTermsOverlayVisible(true);
  const handleCloseTermsOverlay = () => setTermsOverlayVisible(false);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate('/');
  };

  const resetAppState = (e) => {
    e.preventDefault();
    window.location.reload();
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      setIsLogoPressed(true);
      setTimeout(() => setIsLogoPressed(false), 500);
    }, 600000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="app-header-container">
      <header className="app-header">
        <div className="logo-container">
          <span className="app-name">
            <Trans i18nKey="common.appNameLogo" components={[<BwossyLogo />]} />
          </span>
          {/*<img
            src={logo}
            alt={t('customNavbar.logoAltText')}
            className={`app-logo ${isLogoPressed ? 'pressed' : ''}`}
            onClick={resetAppState}
          />
          <a href="/" className="app-name" onClick={resetAppState}>
            {t('common.appName')}
          </a>*/}
        </div>
        <Menu right itemListElement="div" noOverlay>
          <div className="bm-menu-content">

            <button className="bm-item" onClick={handleOpenAccountOverlay}>
              {t('customNavbar.accountLabel')}
            </button>
            <button className="bm-item" onClick={handleLogout}>
              {t('customNavbar.logoutLabel')}
            </button>
          
            {/* Footer Links */}
            <div className="bm-footer-stacked-links">
            <a
                href="/privacy"
                className="bm-footer-stacked-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenPrivacyOverlay();
                }}
              >
                {t('customNavbar.privacyLabel')}
              </a>
              <a
                href="/terms"
                className="bm-footer-stacked-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenTermsOverlay();
                }}
              >
                {t('customNavbar.termsLabel')}
              </a>
            </div>
            {/*<div className="bm-footer-links">
            <a
                href="#"
                className="bm-footer-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenPrivacyOverlay();
                }}
              >
                {t('customNavbar.privacyLabel')}
              </a>
              <a
                href="#"
                className="bm-footer-link"
                onClick={(e) => {
                  e.preventDefault();
                  handleOpenTermsOverlay();
                }}
              >
                {t('customNavbar.termsLabel')}
              </a>
            </div>*/}
          </div>
        </Menu>

      </header>
      <Donate
        isVisible={isDonateOverlayVisible}
        onClose={handleCloseDonateOverlay}
      />
      <Account
        isVisible={isAccountOverlayVisible}
        onClose={handleCloseAccountOverlay}
      />
      <PrivacyPolicy
        isVisible={isPrivacyOverlayVisible}
        onClose={handleClosePrivacyOverlay}
      />
      <TermsAndConditions
        isVisible={isTermsOverlayVisible}
        onClose={handleCloseTermsOverlay}
      />
    </div>
  );
};

export default CustomNavbar;